const FundingSources = () => {
  const container = "#funding-pie-chart";

  const data = [
    { type: "taxes", value: 78 },
    { type: "state park fees", value: 13 },
    { type: "development fees", value: 6 },
    { type: "wastewater surcharge", value: 3 },
    // { type: 'other', value: 0 },
  ];

  const width = 500;
  const height = Math.min(width, 500);
  const radius = Math.min(width, height) / 2;

  const color = d3.scaleOrdinal(d3.schemeCategory10);

  const pie = d3.pie().value(d => d.value);

  const arc = d3
    .arc()
    .innerRadius(radius - 100)
    .outerRadius(radius - 20);

  const svg = d3
    .select(container)
    .append("svg")
    .attr("width", width)
    .attr("height", height)
    .style("margin-left", "8%")
    .append("g")
    .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

  const path = svg
    .datum(data)
    .selectAll("path")
    .data(pie)
    .enter()
    .append("path")
    .attr("fill", (d, i) => color(i))
    .attr("d", arc)
    .each(function(d) {
      this._current = d;
    }); // store the initial angles

  const text = svg
    .selectAll("text")
    .data(pie)
    .enter()
    .append("text")
    .attr("transform", d => `translate(${arc.centroid(d)})`)
    .attr("dy", "0.35em");

  text
    .append("tspan")
    .attr("x", "-0.4em")
    .attr("y", 0)
    .style("font-weight", "bold")
    .style("font-size", "1.4rem")
    .style("text-align", "center")
    .style("fill", "#FFF")
    .text(d => `${d.data.value}%`);

  const legend = d3
    .select(container)
    .append("div")
    .attr("class", "funding-legend");

  const legendItems = d3
    .select(".funding-legend")
    .selectAll(".funding-legend-item")
    .data(data);

  legendItems
    .enter()
    .append("div")
    .attr("class", "funding-legend-item")
    .style("margin-top", "25px");

  d3.selectAll(".funding-legend-item")
    .append("div")
    .attr("class", "funding-legend-rect")
    .style("width", "40px")
    .style("height", "20px")
    .style("background-color", function(d, i) {
      return color(i);
    });

  d3.selectAll(".funding-legend-item")
    .append("div")
    .attr("class", "funding-legend-text")
    .text(d => d.type);
};

const FundingSplit = () => {
  const container = "#funding-pie-chart";

  const data = [
    { type: "Pollution Abatement Projects", value: 60 },
    { type: "Special Projects", value: 40 },
  ];

  const width = 500;
  const height = Math.min(width, 500);
  const radius = Math.min(width, height) / 2;

  const color = d3.scaleOrdinal(d3.schemeCategory10);

  const pie = d3.pie().value(d => d.value);

  const arc = d3
    .arc()
    .innerRadius(radius - 100)
    .outerRadius(radius - 20);

  const svg = d3
    .select(container)
    .append("svg")
    .attr("width", width)
    .attr("height", height)
    .style("margin-left", "8%")
    .append("g")
    .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

  const path = svg
    .datum(data)
    .selectAll("path")
    .data(pie)
    .enter()
    .append("path")
    .attr("fill", (d, i) => color(i))
    .attr("d", arc)
    .each(function(d) {
      this._current = d;
    }); // store the initial angles

  const text = svg
    .selectAll("text")
    .data(pie)
    .enter()
    .append("text")
    .attr("transform", d => `translate(${arc.centroid(d)})`)
    .attr("dy", "0.35em");

  text
    .append("tspan")
    .attr("x", "-0.4em")
    .attr("y", 0)
    .style("font-weight", "bold")
    .style("font-size", "1.4rem")
    .style("text-align", "center")
    .style("fill", "#FFF")
    .text(d => `${d.data.value}%`);

  const legend = d3
    .select(container)
    .append("div")
    .attr("class", "funding-legend");

  const legendItems = d3
    .select(".funding-legend")
    .selectAll(".funding-legend-item")
    .data(data);

  legendItems
    .enter()
    .append("div")
    .attr("class", "funding-legend-item")
    .style("margin-top", "25px");

  d3.selectAll(".funding-legend-item")
    .append("div")
    .attr("class", "funding-legend-rect")
    .style("width", "40px")
    .style("height", "20px")
    .style("background-color", function(d, i) {
      return color(i);
    });

  d3.selectAll(".funding-legend-item")
    .append("div")
    .attr("class", "funding-legend-text")
    .text(d => d.type);
};

const CIPTable = () => {
  const CIPData = [
    {
      "Project Title":
        "Cherry Creek Stream Planning and Approach Study (related to: Cherry Creek at Shop Creek Trail, CCB-5.13; and Cherry Creek 12-mile, CCB-5.16)",
      Total: "$125",
      "Authority Portion": "$125",
      "Proposed 2020 Budget": "$125",
      "Out-year Budget": "---",
      "Funding Year(s)": 2020,
    },
    {
      "Project Title": "CCSP Meteorological Station",
      Total: "$30",
      "Authority Portion": "$30",
      "Proposed 2020 Budget": "$20",
      "Out-year Budget": "---",
      "Funding Year(s)": 2020,
    },
    {
      "Project Title":
        "Reservoir Destratification System - Upgrade (Pending WWE Evaluation Report)",
      Total: "$300",
      "Authority Portion": "$300",
      "Proposed 2020 Budget": "$300",
      "Out-year Budget": "---",
      "Funding Year(s)": 2020,
    },
    {
      "Project Title": "East Boat Ramp Shoreline Stabilization Phase III",
      Total: "$350",
      "Authority Portion": "$350",
      "Proposed 2020 Budget": "$50",
      "Out-year Budget": "$300",
      "Funding Year(s)": "2020-2021",
    },
    {
      "Project Title": "East Shade Shelter Shoreline Stabilization Phase II",
      Total: "$60",
      "Authority Portion": "$60",
      "Proposed 2020 Budget": "$60",
      "Out-year Budget": "---",
      "Funding Year(s)": 2020,
    },
    {
      "Project Title": "West Shade Shelter Shoreline Stabilization PRF",
      Total: "$950",
      "Authority Portion": "$950",
      "Proposed 2020 Budget": "$925",
      "Out-year Budget": "---",
      "Funding Year(s)": 2020,
    },
    {
      "Project Title": "Tower Loop Shoreline Stabilization Phase II",
      Total: "$700",
      "Authority Portion": "$700",
      "Proposed 2020 Budget": "$110",
      "Out-year Budget": "$590",
      "Funding Year(s)": "2020-2022",
    },
    {
      "Project Title":
        "Cherry Creek Stream Stabilization at Main Street (Parker)",
      Total: "$1,776",
      "Authority Portion": "$200",
      "Proposed 2020 Budget": "---",
      "Out-year Budget": "$200",
      "Funding Year(s)": 2025,
    },
    {
      "Project Title":
        "Cherry Creek Stream Stabilization at Lincoln Avenue (Parker)",
      Total: "$1,447",
      "Authority Portion": "$304",
      "Proposed 2020 Budget": "---",
      "Out-year Budget": "$304",
      "Funding Year(s)": 2026,
    },
    {
      "Project Title":
        "Cherry Creek Stream Stabilzation at Shop Creek (Phase I - monitoring station improvements 2020, Phase II Drop Structure Improvement 2021, Phase III Partnered Project TBD)",
      Total: "$603",
      "Authority Portion": "$603",
      "Proposed 2020 Budget": "$150",
      "Out-year Budget": "$453",
      "Funding Year(s)": "2020-2022",
    },
    {
      "Project Title": "Cherry Creek Stream Reclamation – Reach 3",
      Total: "$2,567",
      "Authority Portion": "$640",
      "Proposed 2020 Budget": "---",
      "Out-year Budget": "$640",
      "Funding Year(s)": "2022-2023",
    },
    {
      "Project Title": "Cherry Creek Stream Reclamation – Reach 4",
      Total: "$2,720",
      "Authority Portion": "$680",
      "Proposed 2020 Budget": "$180",
      "Out-year Budget": "$500",
      "Funding Year(s)": "2020-2022",
    },
    {
      "Project Title":
        "Cherry Creek Stream Reclamation - CCSP 12-mile Phase III",
      Total: "$490",
      "Authority Portion": "$490",
      "Proposed 2020 Budget": "$140",
      "Out-year Budget": "$304",
      "Funding Year(s)": "2020-2021",
    },
    {
      "Project Title":
        "Cherry Creek Stream Reclamation - U/S Scott Road (Douglas County)",
      Total: "$2,500",
      "Authority Portion": "$625",
      "Proposed 2020 Budget": "$350",
      "Out-year Budget": "$275",
      "Funding Year(s)": "2020-2021",
    },
    {
      "Project Title":
        "Cherry Creek Stream Reclamation - D/S Pine Drive aka KOA property (Parker)",
      Total: "$1,835",
      "Authority Portion": "$375",
      "Proposed 2020 Budget": "$205",
      "Out-year Budget": "---",
      "Funding Year(s)": 2020,
    },
    {
      "Project Title": "McMurdo Gulch Reclamation (Castle Rock)",
      Total: "$4,157",
      "Authority Portion": "$1,040",
      "Proposed 2020 Budget": "$60",
      "Out-year Budget": "$560",
      "Funding Year(s)": "2020-2024",
    },
    {
      "Project Title":
        "Cottonwood Creek at Briarwood - South reach = 850 ft and North reach = 700 ft",
      Total: "$1,550",
      "Authority Portion": "$388",
      "Proposed 2020 Budget": "---",
      "Out-year Budget": "$388",
      "Funding Year(s)": "2024-2025",
    },
    {
      "Project Title": "Lone Tree Creek in CCSP",
      Total: "$2,800",
      "Authority Portion": "$700",
      "Proposed 2020 Budget": "---",
      "Out-year Budget": "$700",
      "Funding Year(s)": "2021-2022",
    },
    {
      "Project Title": "PRF Preservation, Acquisition, Lease of Land or Water",
      Total: "$500",
      "Authority Portion": "$500",
      "Proposed 2020 Budget": "$50",
      "Out-year Budget": "$450",
      "Funding Year(s)": "2020-2029",
    },
    {
      "Project Title": "Total Capital Projects",
      Total: "$25,460",
      "Authority Portion": "$9,060",
      "Proposed 2020 Budget": "$2,725",
      "Out-year Budget": "$5,664",
      "Funding Year(s)": "",
    },
    {
      "Project Title": "Rehabilitation",
      Total: "",
      "Authority Portion": "",
      "Proposed 2020 Budget": "$90",
      "Out-year Budget": "$810",
      "Funding Year(s)": "2021-2029",
    },
    {
      "Project Title": "Restorative",
      Total: "",
      "Authority Portion": "",
      "Proposed 2020 Budget": "$151",
      "Out-year Budget": "$790",
      "Funding Year(s)": "2021-2029",
    },
    {
      "Project Title": "Routine",
      Total: "",
      "Authority Portion": "",
      "Proposed 2020 Budget": "$115",
      "Out-year Budget": "$1,046",
      "Funding Year(s)": "2021-2029",
    },
    {
      "Project Title": "Operations",
      Total: "",
      "Authority Portion": "",
      "Proposed 2020 Budget": "$40",
      "Out-year Budget": "---",
      "Funding Year(s)": "2021-2029",
    },
    {
      "Project Title": "Total Operations and Maintenance",
      Total: "",
      "Authority Portion": "",
      "Proposed 2020 Budget": "$396",
      "Out-year Budget": "$2,646",
      "Funding Year(s)": "2020-2028",
    },
  ];

  // Declare and configure request overview table
  const table = new requestTable({
    container: "#cip-table",
    filterEnabled: false,
    tableHeaders: {
      "Project Title": "Project Title",
      Total: "Current Total Budget",
      "Authority Portion": "Current Authority Portion",
      "Proposed 2020 Budget": "Proposed 2020 Budget",
      "Out-year Budget": "Out-year Budget",
      "Funding Year(s)": "Funding Year(s)",
    },
    tableActions: [],
    tableData: CIPData,
  });
  table.buildTable();
};
